export const HOTEL_FETCH_RULE_SINGLE = "hotel/FETCH_RULE_SINGLE";
export const HOTEL_SUCCESS_FETCH_RULE_SINGLE = "hotel/SUCCESS_FETCH_RULE_SINGLE";
export const HOTEL_GET_EMPLOYEE_LEVELS = "hotel/GET_EMPLOYEE_LEVELS";
export const FETCH_LOCATION_DATA_FOR_RULE = "hotels/FETCH_LOCATION_DATA_FOR_RULE";
export const HOTEL_SUBMIT_POLICY = "hotels/HOTEL_SUBMIT_POLICY";
export const HOTEL_SUBMIT_POLICY_SUCCESS = "hotels/HOTEL_SUBMIT_POLICY_SUCCESS";
export const HOTEL_SUBMIT_POLICY_FAILURE = "hotels/HOTEL_SUBMIT_POLICY_FAILURE";
export const RESET_HOTEL_STATE = "hotels/RESET_HOTEL_STATE";
